import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import Table from '../../../../components/table/Table';
import Modal from '../../../../components/template/Modal';
import ServiceNewModal from './ServiceNewModal';
import DirectLink from '../../../../components/template/DirectLink';
import Spinner from '../../../../components/template/Spinner';
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import api from '../../../../components/utils/api';

const BIZ_DEPLOYABLE_MODEL_PREFIXES = ['tflite', 'onnx'];

const ServicePage = () => {
    const { mergeRuleId } = useParams();
    const [modalVisible, setModalVisible] = useState(false);
    const [data, setData] = useState([])
    const openModal = () => { setModalVisible(true); }
    const closeModal = () => { setModalVisible(false); }

    useEffect(() => {
        const fetchServices = async () => {
            try {
                const res = await api.get(`/api/merge-rules/${mergeRuleId}/services`)
                setData(res.data)
            } catch (err) {
                console.error(err)
            }
        }

        if (mergeRuleId) {
            fetchServices()
        }
    }, [mergeRuleId])

    const columns = useMemo(
        () => [
            {
                Header: "ID",
                accessor: "id",
            },
            {
                Header: "Group",
                accessor: "group_name",
            },
            {
                Header: "Name",
                accessor: "name",
            },
            {
                Header: "Model Type",
                accessor: "model_type_col",
                Cell: ({ row }) => <div>{row.original.model_type.join(", ")}</div>
            },
            {
                Header: "Converted Model",
                accessor: "converted_model_col",
                Cell: ({ row }) => (
                    <div>
                        <div>{row.original.converted_model.name}</div>
                        {row.original.fe_variants?.length > 1 &&
                            <span className={`mt-1 inline-block rounded text-xs font-semibold px-1.5 py-0.5 ${row.original.fe_variant === 'stft' ? 'bg-blue-100 text-blue-700' : 'bg-emerald-100 text-emerald-700'}`}>
                                {row.original.fe_variant === 'stft' ? 'STFT' : 'Conv1d'}
                            </span>}
                    </div>
                )
            },
            {
                Header: "Google Storage",
                accessor: "path",
                Cell: ({ row }) => (<>{
                    row.original.status === 1 ?
                        <DirectLink path={`https://console.cloud.google.com/storage/browser/${row.original.path}`} title={`Direct link to the google storage link for ${row.original.name} service of ${row.original.group_name}`} />
                        : <div className='h-10 w-32 text-gray-500 border border-gray-400 rounded text-xs m-auto flex'>
                            <div className='pt-2 pl-2'><Spinner /></div>
                            <div className='m-auto cursor-default'>Exporting...</div>
                        </div>
                }</>)
            },
            {
                Header: "Deploy",
                accessor: "deployment",
                Cell: ({ row }) => {
                    if (row.original.status !== 1) {
                        return (
                            <div className='h-10 w-32 text-gray-500 border border-gray-400 rounded text-xs m-auto flex'>
                                <div className='pt-2 pl-2'><Spinner /></div>
                                <div className='m-auto cursor-default'>Exporting...</div>
                            </div>
                        );
                    }
                    const isDeployable = BIZ_DEPLOYABLE_MODEL_PREFIXES.some(
                        prefix => row.original.converted_model.name.startsWith(prefix)
                    );
                    if (isDeployable) {
                        return <DirectLink path={`${process.env.REACT_APP_BIZ_DOMAIN}/models?service_id=${row.original.id}`} title="Direct link for the model deployment" />;
                    }
                    return (
                        <span className="text-gray-300 cursor-not-allowed" title="Only tflite and onnx models can be deployed">
                            <FontAwesomeIcon icon={faArrowUpRightFromSquare} size="lg" />
                        </span>
                    );
                }
            },
            {
                Header: "Threshold",
                accessor: "threshold_col",
                Cell: ({ row }) => <div>{row.original.threshold.name}</div>
            },

        ], []
    )

    return (
        <div>
            <Table data={data} columns={columns} additionalButton={{ contents: "New Service", onClick: () => openModal() }} />
            {modalVisible && <Modal
                visible={modalVisible}
                closable={true}
                maskClosable={true}
                onClose={closeModal}>{
                    <ServiceNewModal mergeRuleId={mergeRuleId} closeModal={closeModal} />
                }</Modal>}
        </div>
    )
}

export default ServicePage